@defer (when items) {
  <div class="lm-container" [class.lm-icons]="isTextMenu === false" [class.force-hide]="forceHide">
    @for (item of items; track item) {
      <div class="{{ item.size }} alarms-{{ alarmCount() }}" routerLink="{{ item.route }}" routerLinkActive="active2" [routerLinkActiveOptions]="{ exact: false }" (click)="menuClick(item.route, $event)" [class.in-alarm]="item.hasAlarmCount && alarmCount()" title="{{ item.description }}" tooltipPosition="right" appendTo="body">
        <div><i class="mdi mdi-{{ item.icon }}"></i></div>
        <div class="title">
          <span>{{ item.title }}</span>
        </div>

        @if (item.hasAlarmCount && alarmCount() && isTextMenu) {
          <div title="{{ alarmCount() }} alarm{{ alarmCount() > 1 ? 's' : '' }}" tooltipPosition="right" appendTo="body">
            <span>{{ alarmCount() }}</span>
          </div>
        }
      </div>
    }
    <div class="lm-expand-shrink" (click)="toggleMenu()" [title]="isTextMenu ? 'Icons only' : 'Keep open'" appendTo="body">
      <div><i class="mdi" [class.mdi-format-horizontal-align-left]="isTextMenu" [class.mdi-dock-left]="!isTextMenu"></i></div>
    </div>
  </div>
  <div #input></div>
} @placeholder {
  <i class="fa fa-spin fa-refresh"></i>
}
